// extracted by mini-css-extract-plugin
export default {"wrapper":"Majik_wrapper__DAtYP","container":"Majik_container__u+5a8"};